/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import { hideModal } from '../../actions/actions';
import PdfModal from './pdf.modal';
import { browserVersion, isIE } from 'react-device-detect';

export const mapStateToProps = (store, ownProps) => {
  return {
    pdfArrayBuffer: store.pdf.pdfArrayBuffer,
    objectBlob: store.pdf.objectBlob,
    pdfError: store.pdf.pdfError,
    isFetchingPdf: store.pdf.isFetchingPdf,
    documentName: ownProps.ownProps,
    browserVersion: browserVersion,
    isIE: isIE
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    closePdf: () => {
      dispatch(hideModal());
    }
  };
};

const PdfModalContainer = connect(mapStateToProps, mapDispatchToProps)(PdfModal);

export default PdfModalContainer;
